import { SAVE_ERROR_REPONSE_RESET_PASSWORD } from './action';

export function forgotPasswordReducer(state=null, action){
    switch (action.type) {

        case SAVE_ERROR_REPONSE_RESET_PASSWORD:
          return action.payload ;
    
        default:
          return state;
    };
   }
   
export default forgotPasswordReducer;
